<template>
    <div>
        <empty-table-message v-if="isEmpty" />
        <b-table
            v-else
            :data="movimentacoes"
            class="data-table table-overflow"
            @sort="sortTable"
            backend-sorting
            detailed
            custom-detail-row
            detail-key="customRowKey"
            custom-row-key="customRowKey"
            :show-detail-icon="false"
            detail-transition="fade"
        >
            <b-table-column
                v-for="(f, i) in fields"
                :key="i"
                :field="f.key"
                :label="f.label ? $t(f.label) : ''"
                :width="f.width"
                :sortable="f.sortable"
                :visible="f.visible"
                :header-class="
                    f.key == 'label' && !isMobile() ? 'remove-space' : ''
                "
                :cell-class="
                    f.key == 'label' && !isMobile() ? 'remove-space' : ''
                "
            >
                <template v-slot:header="{ column }">
                    <a
                        v-if="!column.label"
                        role="button"
                        @click="toggleAllButton"
                    >
                        <span class="icon">
                            <i
                                :class="{
                                    clicked: isAllToggled,
                                }"
                                class="transition mdi mdi-chevron-right mdi-24px"
                            ></i>
                        </span>
                    </a>
                    {{ column.label }}
                    <b-icon
                        v-if="sharedFilters.column === column.field"
                        :icon="`arrow-${sharedFilters.order == 'asc' ? 'up' : 'down'}`"
                        size="is-small"
                    />
                </template>
                <template v-slot="props" v-if="f.key === 'collapse'">
                    <ChevronIcon
                        ref="collapseButton"
                        :tableProps="props"
                        @checkIfIsAllToggled="checkIfIsAllToggled"
                    />
                </template>
                <template v-slot="props" v-else-if="f.key === 'dataHora'">
                    <strong>
                        {{
                            props.row[f.key]
                                ? $moment(props.row[f.key]).format("L")
                                : "--"
                        }}
                    </strong>
                </template>
                <template v-slot="props" v-else-if="f.key === 'saldoLiberado' || f.key === 'saldoGerado'">
                    <strong :class="{ 'is-debit': props.row[f.key] < 0 }">
                        {{
                            new Intl.NumberFormat("pt-BR", {
                                style: "currency",
                                currency: "BRL",
                            }).format(props.row[f.key] ? props.row[f.key] : 0)
                        }}
                    </strong>
                </template>
                <template v-slot v-else>
                    <strong>{{ "--" }}</strong>
                </template>
            </b-table-column>

            <template slot="detail" slot-scope="props">
                <DetalhesMovimentacao
                    :dataHora="props.row.dataHora"
                    :isMobile="isMobile"
                    :sortTable="sortTable"
                    :sharedFilters="sharedFilters"
                />
            </template>
        </b-table>
    </div>
</template>

<script>
import DetalhesMovimentacao from "./DetalhesMovimentacao";
import ChevronIcon from "./ChevronIcon";

export default {
    name: "MovimentacaoTable",
    components: {
        DetalhesMovimentacao,
        ChevronIcon,
    },
    props: {
        movimentacoes: {
            type: Array,
            default: (_) => [],
        },
        isMobile: {
            type: Function,
            default: () => {},
        },
        sortTable: {
            type: Function,
            default: () => {},
        },
        isEmpty: {
            type: Boolean,
            default: true,
        },
        isLoading: {
            type: Boolean,
            default: true,
        },
        sharedFilters: {
            type: Object,
            default: () => {},
        }
    },
    data() {
        return {
            fields: [
                {
                    key: "collapse",
                    label: null,
                    width: null,
                    sortable: false,
                    visible: true,
                },
                {
                    key: "codigo",
                    label: "codigo",
                    width: null,
                    sortable: false,
                    visible: true,
                },
                {
                    key: "dataHora",
                    label: "data-hora",
                    width: null,
                    sortable: true,
                    visible: true,
                },
                {
                    key: "lancamento",
                    label: "lancamento",
                    width: null,
                    sortable: false,
                    visible: true,
                },
                {
                    key: "criadoPor",
                    label: "criado-por",
                    width: null,
                    sortable: false,
                    visible: true,
                },
                {
                    key: "motivoLancamento",
                    label: "motivo-lancamento",
                    width: null,
                    sortable: false,
                    visible: true,
                },
                {
                    key: "observacao",
                    label: "observacao",
                    width: null,
                    sortable: false,
                    visible: true,
                },
                {
                    key: "tipo",
                    label: "tipo",
                    width: null,
                    sortable: false,
                    visible: true,
                },
                {
                    key: "saldoGerado",
                    label: "saldo-gerado",
                    width: null,
                    sortable: true,
                    visible: true,
                },
                {
                    key: "saldoLiberado",
                    label: "saldo-liberado",
                    width: null,
                    sortable: true,
                    visible: true,
                },
            ],
            isAllToggled: false,
            showDetailIcon: true,
        };
    },
    methods: {
        setIsAllToggled(state) {
            this.isAllToggled = state
        },
        toggleAllButton() {
            const isAllToggled = this.$refs.collapseButton.every(
                (button) => button.isClicked
            );

            this.$refs.collapseButton.forEach((button) => {
                if (isAllToggled) {
                    button.toggleButton();
                } else if (!button.isClicked) {
                    button.toggleButton();
                }
            });
        },
        checkIfIsAllToggled() {
            if(this.$refs.collapseButton) {
                const isAllToggled = this.$refs.collapseButton.every(
                    (button) => button.isClicked
                );

                this.isAllToggled = isAllToggled;
            }
        },
    },
};
</script>
<style lang="scss">
@media screen and (min-width: 760px) {
    .table-overflow {
        .table {
            min-width: 990px;
            .remove-space {
                padding-left: 0;
                margin-left: 0;
                padding-right: 0;
                margin-right: 0;
            }
        }
    }
}
</style>

<style lang="scss" scoped>
.transition {
    transition: all 300ms ease-in-out;
}

.clicked {
    transform: rotate(90deg);
}

.is-debit {
    color: #f44336;
}
.g-2 {
    gap: 8px;
}
// Barra de filtro
.label-situacao {
    position: absolute;
    bottom: 5px;
    top: 5px;
    display: flex;

    .bar {
        border-radius: 100px;
        width: 5px;
        min-height: 25px;
        height: 100%;
        &.bar-finalizada {
            background-color: #84bd42;
        }
        &.bar-aberta {
            background-color: #fd5858;
        }
    }
}
.sovis-tag {
    display: inline-block;
    text-transform: capitalize;
    text-align: center;
    font-size: 11px;
    padding: 3px 5px;
    border-radius: 4px;
    color: #fff;
    margin: 1px;
    cursor: pointer;

    &.is-success {
        background-color: $green-alert;
    }
    &.is-danger {
        background-color: $orange;
    }
}
.sovis-container-user {
    cursor: pointer;
    padding: 2px 10px;
    border: solid 1px $primary-color;
    background-color: #f0f0f0;
    border-radius: 6px;
    display: flex;
    position: absolute;
    @media screen and (max-width: 850px) {
        position: relative;
    }
    .qtd-users {
        font-weight: bolder;
        font-size: 18px;
        margin: 0 10px;
        &.is-success {
            color: $green-alert;
        }
        &.is-danger {
            color: $orange;
        }
    }
}
</style>
